import IconButton from "@mui/material/IconButton";
import Tables from "components/Tables";
import Modal from "components/Modal";
import AthleteBulkEdit from "components/AthleteBulkEdit";
import OneRepMaxProvider from "providers/OneRepMaxProvider";
import { useCallback, useState } from "react";
import useMultiSelectIds from "providers/MultiSelectProvider/useMultiSelectIds";
import TooltipHelper from "components/TooltipHelper";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";

interface AthleteTableControlsBulk1rmEditProps {}

function AthleteTableControlsBulk1rmEdit(props: AthleteTableControlsBulk1rmEditProps) {
  const [open, setOpen] = useState(false);
  const selectedIds = useMultiSelectIds();
  const { t } = useTranslation();

  const disableBulkEdit = Boolean(!selectedIds.length);

  const toggleOpen = useCallback(() => setOpen((prev) => !prev), []);

  return (
    <>
      <ThemeProvider2024>
        <TooltipHelper title={t("athlete.bulk_edit1rm_tooltip_title")} placement="top">
          <span>
            <IconButton
              size="small"
              color="primary"
              disabled={disableBulkEdit}
              onClick={toggleOpen}
              aria-label={t("athlete.bulk_edit1rm_tooltip_title")}
            >
              <Tables.Icons.OneRepMax />
            </IconButton>
          </span>
        </TooltipHelper>
      </ThemeProvider2024>
      <Modal open={open} toggleOpen={toggleOpen}>
        <OneRepMaxProvider>
          <AthleteBulkEdit athleteIds={selectedIds} onCancel={toggleOpen} />
        </OneRepMaxProvider>
      </Modal>
    </>
  );
}

export default AthleteTableControlsBulk1rmEdit;
